import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=5fa10caf&scoped=true"
import script from "./tutorial.vue?vue&type=script&lang=js"
export * from "./tutorial.vue?vue&type=script&lang=js"
import style0 from "./tutorial.vue?vue&type=style&index=0&id=5fa10caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa10caf",
  null
  
)

export default component.exports